import { useCallback } from 'react';

import ToastComponent, { IToastType } from '../components/Toast/ToastComponent';
import { useCreatePintoEbookCollectionMutation } from '../core/graphql/operation-hooks';
import { CreatePintoEbookCollectionInput } from '../core/graphql/types';

const useMutationCreateEbookCollection = () => {
  const [mutate, { loading }] = useCreatePintoEbookCollectionMutation();

  const createEbookCollection = useCallback(
    async (input: CreatePintoEbookCollectionInput) => {
      try {
        const res = await mutate({ variables: { input } });
        if (res.data?.createPintoEbookCollection?._id) {
          return { success: true, data: res.data.createPintoEbookCollection };
        } else {
          ToastComponent({ label: 'Create failed.', type: IToastType.ERROR });
          return { success: false };
        }
      } catch (err) {
        ToastComponent({ label: 'An error occurred.', type: IToastType.ERROR });
        return { success: false };
      }
    },
    [mutate],
  );

  return { createEbookCollection, isCreating: loading };
};

export default useMutationCreateEbookCollection;
